<template>
    <div class="form-group row">
        <div class="col-12" v-if="title">
            <label class="typo__label">{{ title }}</label>
        </div>
        <div class="col-12 d-flex webbiz-multiselect-wrapper">
            <multiselect 
                v-model="inputVal"
                :label="label ? label : 'name'" 
                :track-by="trackby ? trackby : 'id'" 
                :placeholder="placeholder ? placeholder : 'Scrivi per cercare...'"
                :options="options"
                :loading="loading"
                :multiple="multiple"
                :searchable="searchable"
                :closeOnSelect="closeOnSelect"
                :hideSelected="hideSelected"
                :class="{ 'disabled': disabled, ...inputclass } " 
                :show-labels="showlabels ? showlabels : false"
                :max="max"
                :option-height="optionheight"
                @input="input($event)" 
                @search-change="debounce($event)"
                @select="select($event)"
                @remove="remove($event)"
            >
            <template slot="clear">
                <div class="multiselect__clear" v-if="value && !noremove" @mousedown.prevent.stop="clearValue()">
                    <i class="far fa-trash-alt trash-icon"></i>
                </div>
            </template>

            <template slot="maxElements">
                E' stato raggiunto il massimo numero di opzioni selezionabili.
            </template>
            
            <span slot="noResult">Nessun elemento trovato</span>
            <span slot="noOptions">Effettuare una ricerca...</span>
            
            </multiselect>
        </div>
    </div>
</template>

<script>

import Multiselect from 'vue-multiselect'

export default {
    components: { Multiselect },
    props: [
        'title',
        'value',
        'label',
        'trackby',
        'disabled',
        'placeholder',
        'options',
        'inputclass',
        'multiple',
        'loading',
        'searchable',
        'showlabels',
        'noremove',
        'evidence',
        'max',
        'preload',
        'preloadfunction',
        'closeOnSelect',
        'hideSelected',
        'optionheight',
        'preloadonetime'
    ],
    mounted() {
        if(this.preload) {
            this.$emit('search-change', ' ');
        }

        this.debounce = _.debounce((event) => this.search(event), 800);
    },
    methods: {
        input(event) {
            this.$emit('input', event);
        },
        search(event) {
            if(!this.preload) {
                this.$emit('search-change', event);
            }
        },
        select(event) {
            this.$emit('select', event);
        },
        remove(event) {
            this.$emit('remove', event);
        },
        clearValue() {
            this.$emit('clearValue');
        },
    },
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {}
        }
    },
    data() {
        return {
            debounce: null
        }
    }
}
</script>

<style lang="scss" scoped>
    .evidence_option {
        float: right;
    }
    .evidence_label {
        margin-right: 25px;
        float: right;
    }

    .typo__label {
        color: var(--primary);
    }

    ::v-deep .multiselect__option--highlight {
        background-color: var(--primary);
    }

    /** Spinner */
    ::v-deep .multiselect__spinner {
        &::before {
            border-top-color: var(--primary); ;
        }
        &::after {
            border-top-color: var(--primary); ;
        }  
    }

    /** Disabled */
    ::v-deep .multiselect {
        &.disabled {
            pointer-events: none;

            .multiselect__input, .multiselect__single {
                background-color: transparent !important;
            }
            .multiselect__tags {
                background-color: #f8fafc !important;
            }
        }
    }
</style>